export var SourceType;
(function (SourceType) {
    SourceType[SourceType["HELP_CENTER"] = 0] = "HELP_CENTER";
    SourceType[SourceType["WIDGET"] = 1] = "WIDGET";
    SourceType[SourceType["OLD_WIDGET"] = 2] = "OLD_WIDGET";
})(SourceType || (SourceType = {}));
//# sourceMappingURL=source-type.enum.js.map